import { reducers } from './reducers';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { MetadataState } from './types';

export const initialState: MetadataState = {
  isLoading: false,
  data: {
    ball_valve: [],
    butterfly_valve: [],
  },
  error: null,
};

const slice = createSlice({
  name: 'metadata',
  initialState,
  reducers,
});

export const { actions: metadataActions } = slice;
export const { reducer: metadataReducer } = slice;
